const shopActionTypes = {
  FETCH_COLLECTION_START : 'FETCH_COLLECTION_START',
  FETCH_COLLECTION_SUCCESS : 'FETCH_COLLECTION_SUCCESS',
  FETCH_COLLECTION_FAILURE : 'FETCH_COLLECTION_FAILURE',
  UPDATE_COLLECTIONS : 'UPDATE_COLLECTION'
}

export default shopActionTypes;